import axios from 'axios';
import { API_BASE_URL } from '.';
import { camelizeResponse, decamelizeRequest } from './case-transforms';

// Client for anonymous pages (e.g. the invoice payment link). It sends no
// session headers and skips the logged-in app's global handling (logout,
// token refresh, 2FA and error-boundary redirects): callers handle their own
// errors.
const publicAxios = axios.create({
  baseURL: API_BASE_URL,
});

publicAxios.interceptors.request.use(decamelizeRequest);
publicAxios.interceptors.response.use(camelizeResponse);

export default publicAxios;
